import Component from '@glimmer/component';

export default class LoaderFullscreen extends Component {}
